<template>
  <div class="flow-animation-base-container">
      <div class="topcontainer">
        <div class="hourIndex">
                    Day {{ Math.floor(this.slider / 8) }} Hour
                    {{ 8 * ((this.slider / 8) % 1) }}
                  </div>
        <v-tooltip v-if="!playing" bottom open-delay="500" color="#5774E7">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-1 pa-1" v-bind="attrs" v-on="on" ref="playButton" @click="clickedPlay" elevation="0" height="32px" width="32px" x-small color="white"><v-img src="../../assets/icons/playicon.svg" /></v-btn>
          </template>
          <span>Play the animation</span>
        </v-tooltip>

        <v-tooltip v-else bottom open-delay="500" color="#5774E7">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-1 pa-1" v-bind="attrs" v-on="on" ref="pauseButton" @click="clickedPlay" elevation="0" height="32px" width="32px" x-small color="white"><v-img src="../../assets/icons/pauseicon.svg" /></v-btn>
          </template>
          <span>Pause the animation</span>
        </v-tooltip>

        <div class="slidecontainer">
          <input id="indexslider2" type="range" min="0" :max="this.$store.state.simulator.performanceTracker.metrics.length - 1" @input="(v) => updateIndex(v)" :value="this.slider" class="indexslider" />
        </div>
      </div>
      <div class="local-container">
        <svg ref="svg" class="chart"></svg>
      </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import * as d3Path from "@/math/gradientPath.js";
import { WaitingTimeVisualiser } from "@/visualisation/graphs/waitingTimeAnimations/waitingTimeVisualiser.js";

export default {
  data: () => ({
    slider: 0,
    taskRadioGroup: "tasks",
    projectLineGroup: null,
    resourceLinesGroup: null,
    resourceTransitionLinesGroup: null,
    transitionCirclesGroup: null,
    circlesGroup: null,
    projectGroup: null,
    idToPosition: null,
    svg: null,
    threshold: 0,
    numLastDays: 150,
    playing: false,
    defs: null,
    resourceMask: {},
    transitions: [],
    transitionCount: 0,
    visualPathGroups: {},
    transitionPaths: {},
    minMax: {},
    trainedSubscripts: null,
    capacitySubscripts: null,


    waitingTimeVisualiser: null,
  }),

  beforeMount() {
    // this.$store.state.simulator.automateUntilEnd("EpicFlow", []);

    // this.minMax = this.getMinMaxWaitingTime();
  },

  mounted() {
    var svg = d3.select(this.$refs.svg);
    this.waitingTimeVisualiser = new WaitingTimeVisualiser(this.$store.state, svg, this.defs, this.$store.state.ResourceGroups);
    // this.setupPaths();
    // this.initializeSVG();

    // var self = this;

    // this.updateElements();
  },

  methods: 
  {

  
  updateIndex(val) {
      this.slider = parseInt(val.srcElement.value);
      this.updateElementsv2(true);
    },
    clickedPlay() {
      this.playing = !this.playing;
      this.iterateV2();
    },
    updateElementsv2(withoutCircles=false){
      var metrics = this.$store.state.simulator.performanceTracker.metrics[this.slider];
      if (metrics == null) {
        return;
      }

      this.waitingTimeVisualiser.updateVisuals(metrics, withoutCircles);

    },
    iterateV2(){
      if(!this.playing){
        return;
      }
  

      this.updateElementsv2();

      if(this.slider > this.$store.state.simulator.performanceTracker.metrics.length - 2){
        this.playing = false;
        return;
      }

      this.slider += 1;
      

      setTimeout(() => {
        this.iterateV2();
      }, 100);



    },

    createAllNodes(allNodes) {
      var metrics = this.$store.state.simulator.performanceTracker.metrics[this.slider];

      var projectNodes = allNodes.projectNodes;
      var nodes = allNodes.nodes;
      var self = this;

      var textNodes = {};

      nodes
        .append("circle")
        .attr("id", (_, index) => {
          return `circle-${index}`;
        })
        .attr("r", 40)
        .style("stroke-width", "1px")
        .style("stroke", "#0000004d")
        .style("fill", (d) => {
          return this.resourceIDToGroup(d.id).color;
        });

      nodes;

      this.capacitySubscripts = nodes;

      this.trainedSubscripts = nodes;

      this.trainedSubscripts.attr("dy", "1em").attr("dx", function (d) {
        if (d.id == "I") {
          return -12;
        }
        return -1.75 * this.getBoundingClientRect().width;
      });

      var projectNodes = this.projectGroup
        .selectAll("rect")
        .data(projectNodes)
        .enter()
        .append("g")
        .attr("transform", function (d, i) {
          var pos = self.getOffset(d.x, d.y);
          return "translate(" + pos.x + "," + pos.y + ")";
        });

      projectNodes.append("rect").attr("width", 50).attr("height", 50).attr("fill", "#B2B2B2").attr("style", "outline: thin solid #0000004d;").attr("transform", `rotate(45) translate(${-25},${-25}) `);
    },
    createAllLines(circles, allNodes) {
      var resourceLines = this.getResourceLines(circles);
      this.createDirectResourceLines(circles, resourceLines.directLines);
      this.createSelfResourceLines(circles, resourceLines.selfLines);
      this.createProjectLines(allNodes);
    },
    createProjectLines(allNodes) {
      var projectNodes = allNodes.projectNodes;

      for (let projectNodePos of projectNodes) {
        const fromP = { x: projectNodePos.x, y: projectNodePos.y };
        const toP = this.getOffset(projectNodePos.x, projectNodePos.y);

        const path = d3.path();
        path.moveTo(fromP.x, fromP.y);
        path.lineTo(toP.x, toP.y);
        this.transitionPaths[projectNodePos.id]["X"] = this.resourceTransitionLinesGroup.append("path").style("fill", "none").style("stroke-width", "5px").style("stroke", "#0000004d").attr("d", path).attr("opacity", 1);

        const path2 = d3.path();
        path2.moveTo(toP.x, toP.y);
        path2.lineTo(fromP.x, fromP.y);
        this.transitionPaths["X"][projectNodePos.id] = this.resourceTransitionLinesGroup.append("path").style("fill", "none").style("stroke-width", "2px").style("stroke", "#0000004d").attr("d", path2).attr("opacity", 0);
      }
    },
    createSelfResourceLines(circles, selfLines) {
      for (let line of selfLines) {
        const fromCircle = circles[line.from];
        const fromP = { x: fromCircle.x, y: fromCircle.y };

        if (!this.resourceMask[fromCircle.id][fromCircle.id]) {
          continue;
        }

        var xRotation = 5;
        var largeArc = 1;
        var sweep = 1;
        var drx = 40;
        var dry = 40;

        const path = "M" + fromP.x + "," + fromP.y + "A" + drx + "," + dry + " " + xRotation + "," + largeArc + "," + sweep + " " + (fromP.x + 1) + "," + (fromP.y + 1);

        this.transitionPaths[fromCircle.id][fromCircle.id] = this.resourceTransitionLinesGroup.append("path").style("fill", "none").style("stroke-width", "2px").style("stroke", "#0000004d").attr("d", path).attr("opacity", 0);
      }
    },

    createDirectResourceLines(circles, directLines) {
      var color = d3.interpolateRgb("purple", "orange");

      for (let line of directLines) {
        const fromCircle = circles[line.from];
        const toCircle = circles[line.to];

        const fromP = { x: fromCircle.x, y: fromCircle.y };
        const toP = { x: toCircle.x, y: toCircle.y };
        const controlP = { x: 0, y: 0 }; // The control point in the middle

        //Get the point halfway the path
        // Calculate the midpoint of the curve
        const midPoint = {
          x: (fromP.x + 2 * controlP.x + toP.x) / 4,
          y: (fromP.y + 2 * controlP.y + toP.y) / 4,
        };

        //Spawn a sphere at the midpoint

        // // Calculate the t value for the split point
        // Create the first split curve (from fromP to midPoint)
        const path1 = d3.path();
        path1.moveTo(fromP.x, fromP.y);
        path1.quadraticCurveTo((fromP.x + controlP.x) / 2, (fromP.y + controlP.y) / 2, midPoint.x, midPoint.y);

        // Create the second split curve (from midPoint to toP)
        const path2 = d3.path();
        path2.moveTo(midPoint.x, midPoint.y);
        path2.quadraticCurveTo((controlP.x + toP.x) / 2, (controlP.y + toP.y) / 2, toP.x, toP.y);

        this.visualPathGroups[fromCircle.id][toCircle.id] = this.resourceLinesGroup.append("g");
        this.visualPathGroups[toCircle.id][fromCircle.id] = this.resourceLinesGroup.append("g");

        const path = d3.path();
        //Create the quadratic curve path from the two points and the control point in the middle
        path.moveTo(fromP.x, fromP.y);
        path.quadraticCurveTo(controlP.x, controlP.y, toP.x, toP.y);
        this.transitionPaths[fromCircle.id][toCircle.id] = this.resourceTransitionLinesGroup.append("path").style("fill", "none").style("stroke-width", "2px").style("stroke", "#0000004d").style("opacity", 0).attr("d", path);

        //Apply gradient
        const reversePath = d3.path();
        reversePath.moveTo(toP.x, toP.y);
        reversePath.quadraticCurveTo(0, 0, fromP.x, fromP.y);

        this.transitionPaths[toCircle.id][fromCircle.id] = this.resourceTransitionLinesGroup.append("path").style("fill", "none").style("stroke-width", "2px").style("stroke", "#0000004d").style("opacity", 0).attr("d", reversePath);

        const gradientID1 = `gradient${fromCircle.id}${toCircle.id}`;
        const gradientID2 = `gradient${toCircle.id}${fromCircle.id}`;

        this.setGradientMap(0, 0, fromCircle, toCircle, true);
        this.setGradientMap(0, 0, toCircle, fromCircle, true);

        this.visualPathGroups[fromCircle.id][toCircle.id].append("path").style("fill", "none").style("mix-blend-mode", "darken").style("stroke-width", "5px").style("stroke", `url(#${gradientID1})`).style("opacity", 1).attr("d", path1);
        this.visualPathGroups[toCircle.id][fromCircle.id].append("path").style("fill", "none").style("mix-blend-mode", "darken").style("stroke-width", "5px").style("stroke", `url(#${gradientID2})`).style("opacity", 1).attr("d", path2);

        // this.visualPathGroups[fromCircle.id][toCircle.id].transition().duration(1000).ease(d3.easeLinear).style("stroke", `url(#${gradientID2})`);
        // this.visualPathGroups[toCircle.id][fromCircle.id].transition().duration(1000).ease(d3.easeLinear).style("stroke", `url(#${gradientID1})`);

        if (!this.resourceMask[fromCircle.id][toCircle.id] && !this.resourceMask[toCircle.id][fromCircle.id]) {
          continue;
        }

        continue;

        var newPath = this.transitionPaths[fromCircle.id][toCircle.id];

        this.visualPathGroups[fromCircle.id][toCircle.id] = this.resourceLinesGroup.append("g");
        this.visualPathGroups[fromCircle.id][toCircle.id]
          .selectAll("path")
          .data(d3Path.quads(d3Path.samples(newPath.node(), 10)))
          .enter()
          .append("path")
          .style("stroke", function (d) {
            return color(1 - d.t);
          })
          .style("opacity", 0.25)
          .style("fill-opacity", 1)
          .style("stroke-opacity", 1)
          .style("mix-blend-mode", "darken")

          .attr("d", function (d) {
            return d3Path.lineJoin(d[0], d[1], d[2], d[3], 2);
          })
          .style("fill", function (d) {
            return color(1 - d.t);
          });
      }
    },
    setupPaths() {
      this.getResourceGroups().forEach((group1) => {
        this.visualPathGroups[group1.id] = {};
        this.transitionPaths[group1.id] = {};
      });
      this.visualPathGroups["X"] = {};
      this.transitionPaths["X"] = {};
    },
    initializeSVG() {},
    initializeElements() {
      const circles = this.getCirclePositions();
      var allNodes = this.getAllNodes(circles);

      this.createAllLines(circles, allNodes);
      this.createAllNodes(allNodes);
    },
    

    iterate() {
      if (!this.playing) {
        return;
      }
      var index = this.slider;
      if (index > this.$store.state.simulator.performanceTracker.metrics.length - 1) {
        this.playing = false;
        return;
      }

      this.transitions = this.transitions.concat(this.getTransitions(index));
      var self = this;

      // ANIMATE ALONG PATH FUNCTION
      function translateAlong(mypath) {
        mypath = self.transitionPaths[mypath.group1][mypath.group2].node();
        var length = mypath.getTotalLength();
        return () => {
          return (x) => {
            var p = mypath.getPointAtLength(x * length);
            return "translate(" + p.x + "," + p.y + ")";
          };
        };
      }
      this.transitionCirclesGroup
        .selectAll("circle")
        .data(self.transitions)
        .enter()
        .append("circle")
        .attr("id", "travel")
        .style("fill", (d) => this.resourceIDToGroup(d.group1).color)
        .attr("transform", (d) => {
          var pos = self.getTransitionCircleStartPos(d);
          return "translate(" + pos.x + "," + pos.y + " )";
        })
        .attr("r", function (d) {
          if (d.group1 == "X" || d.group2 == "X" || d.group1 == d.group2) {
            return 3;
          }
          var value = parseInt(self.visualPathGroups[d.group1][d.group2].select("path").style("stroke-width").match(/\d+/)[0]);
          return value / 2;
        });

      this.transitionCirclesGroup.each((d) => {
        d3.selectAll("#travel")
          .filter((d) => !d.started)
          .transition()
          .style("opacity", 1)
          .delay((d) => d.delay)
          .duration(function (d) {
            d.started = true;
            var path = self.transitionPaths[d.group1][d.group2].node();
            return 1000;
            return path.getTotalLength() * 5;
          })
          .attrTween("transform", (d, i) => translateAlong(d)())
          .ease(d3.easeLinear)
          .on("end", function (d) {
            d3.select(this).remove();
            self.transitions.splice(self.transitions.indexOf(d), 1);
          });
      });
      this.updateElements();
      this.slider += 1;

      if (this.slider > this.$store.state.simulator.performanceTracker.metrics.length - 1) {
        return;
      }

      setTimeout(() => {
        this.iterate();
      }, 100);
    },
    getTransitionCircleStartPos(transition) {
      if (transition.group1 == "X") {
        return this.getOffset(this.idToPosition[transition.group2].x, this.idToPosition[transition.group2].y);
      }

      return this.idToPosition[transition.group1];
    },
    getRelativeCumulativeMetrics(group1ID, group2ID) {
      var metrics = this.$store.state.simulator.performanceTracker.metrics[this.slider];
      var numDaysAgo = Math.max(0, this.slider - this.numLastDays * 8);
      var metricsNumDaysAgo = this.$store.state.simulator.performanceTracker.metrics[numDaysAgo];

      return metrics.cumulativeWaitingTimesPerGroup[group1ID][group2ID] - metricsNumDaysAgo.cumulativeWaitingTimesPerGroup[group1ID][group2ID];
    },
    getTransitions(hour) {
      var waitingTimesPerGroup = this.$store.state.simulator.performanceTracker.metrics[hour].waitingTimesPerGroup;
      var increase = 1;

      if (this.taskRadioGroup == "workDays") {
        waitingTimesPerGroup = this.$store.state.simulator.performanceTracker.metrics[hour].waitingTimesPerGroupHours;
        increase = 8;
      }

      var transitions = [];

      var maxCumulativeWaitingTime = this.getCumulativeWaitingTimesPerGroup().max;
      Object.entries(waitingTimesPerGroup).forEach(([group1, group1list]) => {
        Object.entries(group1list).forEach(([group2, value]) => {
          var cumulativeValue = this.$store.state.simulator.performanceTracker.metrics[hour].cumulativeWaitingTimesPerGroup[group1][group2];
          // if (cumulativeValue < (maxCumulativeWaitingTime * this.threshold) / 100) {
          //   return;
          // }

          for (let i = 0; i < value / increase; i++) {
            transitions.push({ group1, group2, value, transitionCount: this.transitionCount, started: false, delay: i * 100 });
            this.transitionCount += 1;
          }
        });
      });
      return transitions;
    },
    updateElements() {
      this.updateLines();
      this.updateNodes();
    },
    
    getCumulativeWaitingTimesPerGroup() {
      var resourceGroups = this.getResourceGroups();

      var cumulativeWaitingTimes = [];
      resourceGroups.forEach((group1) => {
        resourceGroups.forEach((group2) => {
          // path[group1][group2].style("opacity", 1)
          var val1 = this.getRelativeCumulativeMetrics(group1.id, group2.id);
          var val2 = this.getRelativeCumulativeMetrics(group2.id, group1.id);
          var val = Math.max(val1, val2);
          cumulativeWaitingTimes.push({ group1, group2, val });
        });
      });

      var maxWaitingTime = Math.max(...cumulativeWaitingTimes.map((o) => o.val));
      var minWaitingTime = Math.min(...cumulativeWaitingTimes.map((o) => o.val));

      return { cumulativeWaitingTimes, min: minWaitingTime, max: maxWaitingTime };
    },
    getMinMaxWaitingTime() {
      var metrics = this.$store.state.simulator.performanceTracker.metrics;
      if (metrics == null) {
        return;
      }

      var minVal = metrics[0].waitingTime.B;
      var maxVal = metrics[0].waitingTime.B;

      // Foreach waitingTime in the metric, get the min and max
      metrics.forEach((currMetric) => {
        var waitingTime = currMetric.waitingTime;
        waitingTime["G"] = 0;
        //Get the min and max of waitingTime
        var maxWaitingTime = Math.max(...Object.values(waitingTime));
        var minWaitingTime = Math.min(...Object.values(waitingTime));

        minVal = Math.max(minVal, minWaitingTime);
        maxVal = Math.max(maxVal, maxWaitingTime);
      });

      return { min: minVal, max: maxVal };
    },
    updateThreshold(value) {
      this.threshold = value.srcElement.value;
      this.updateLines();
    },
    updateLastDays(value) {
      this.numLastDays = value.srcElement.value;
      this.updateLines();
    },
    updateNodes() {
      var self = this;

      //Create an opacity scale based on current metrics waitingTime
      var metrics = this.$store.state.simulator.performanceTracker.metrics[this.slider];
      if (metrics == null) {
        return;
      }

      //This is a 1d dictionary
      var waitingTime = metrics.waitingTime;
      waitingTime["G"] = 0;
      //Get the min and max of waitingTime
      var maxWaitingTime = Math.max(...Object.values(waitingTime));
      var minWaitingTime = Math.min(...Object.values(waitingTime));
      //Create a scale to map the waiting times to opacity
      var opacityScale = d3.scaleLinear().domain([minWaitingTime, maxWaitingTime]).range([0.25, 1]);

      var colorMapper = {};

      colorMapper["G"] = d3.scaleLinear().domain([minWaitingTime, maxWaitingTime]).range(["gray", "black"]);
      colorMapper["B"] = d3.scaleLinear().domain([minWaitingTime, maxWaitingTime]).range(["#4dbdff", "#0071b3"]);
      colorMapper["I"] = d3.scaleLinear().domain([minWaitingTime, maxWaitingTime]).range(["#0092f3", "#00365a"]);
      colorMapper["P"] = d3.scaleLinear().domain([minWaitingTime, maxWaitingTime]).range(["##ff7bbd", "#e10071"]);
      colorMapper["O"] = d3.scaleLinear().domain([minWaitingTime, maxWaitingTime]).range(["#ffc74c", "#b27a00"]);
      colorMapper["M"] = d3.scaleLinear().domain([minWaitingTime, maxWaitingTime]).range(["#ce6b60", "#722b23"]);
      colorMapper["A"] = d3.scaleLinear().domain([minWaitingTime, maxWaitingTime]).range(["#5befde", "#0fa291"]);

      var grayColorMapper = d3.scaleLinear().domain([minWaitingTime, maxWaitingTime]).range(["gray", "#000000"]);

      this.trainedSubscripts.text(function (d) {
        if (metrics.currTrained[d.id] == null) {
          return "";
        }
        return self.$store.state.simulator.resourcePool.getResourceGroupFromName(metrics.currTrained[d.id]).id;
      });

      this.capacitySubscripts.text(function (d) {
        if (d.id == "G") {
          return "∞";
        }
        return metrics.currWorking[d.id];
      });

      //First stop the circles from transitioning
      //this.circlesGroup.selectAll("circle").transition();
      this.circlesGroup
        .selectAll("circle")
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .style("fill", function (d) {
          return grayColorMapper(waitingTime[d.id]);
          return colorMapper[d.id](waitingTime[d.id]);
        });
    },
    setGradientMap(group1Val, group2Val, fromCircle, toCircle, initialise) {
      const startX = fromCircle.x;
      const startY = fromCircle.y;
      const endX = toCircle.x;
      const endY = toCircle.y; /* y-coordinate of the ending point */

      const controlP = { x: 0, y: 0 }; // The control point in the middle
      //Get the point halfway the path
      // Calculate the midpoint of the curve
      const midPoint = {
        x: (fromCircle.x + 2 * controlP.x + toCircle.x) / 4,
        y: (fromCircle.y + 2 * controlP.y + toCircle.y) / 4,
      };

      const gradientRadius = Math.sqrt((midPoint.x - startX) ** 2 + (midPoint.y - startY) ** 2);
      const gradientID = `gradient${fromCircle.id}${toCircle.id}`;

      var gradient = this.defs.select(`#${gradientID}`);
      if (initialise) {
        gradient = this.defs
          .append("radialGradient")
          .attr("id", gradientID)
          .attr("gradientUnits", "userSpaceOnUse")
          .attr("cx", startX) // x-coordinate of the starting point
          .attr("cy", startY) // y-coordinate of the starting point
          .attr("r", gradientRadius); // Radius is set to the calculated distanc
      }

      // Calculate the radius of the gradient as the distance between start and end points

      var differenceVal = group1Val - group2Val;
      var maxDifference = 10;
      var minDifference = -10;

      differenceVal = Math.max(minDifference, differenceVal);
      differenceVal = Math.min(maxDifference, differenceVal);

      //Scale the differenceVal to a value between -1 and 1
      differenceVal = (2 * differenceVal) / (maxDifference - minDifference);

      //Now scale it to a value between 0 and 1
      differenceVal = (differenceVal + 1) / 2;

      var interpolationFunction = d3.interpolateRdBu;
      interpolationFunction = d3.interpolateRgb("red", "blue");
      interpolationFunction = d3.interpolateGreys;
      interpolationFunction = d3.interpolateYlOrRd;

      differenceVal = 1 - differenceVal;

      var col1 = interpolationFunction(differenceVal);
      var col2 = interpolationFunction(0.5);

      gradient.selectAll("stop").remove();

      gradient.append("stop").attr("offset", "0%").attr("stop-color", col1);
      gradient.append("stop").attr("offset", "100%").attr("stop-color", col2);
    },
    updateLines() {
      var metrics = this.$store.state.simulator.performanceTracker.metrics[this.slider];

      if (metrics == null) {
        return;
      }
      var waitingTimesMetrics = this.getCumulativeWaitingTimesPerGroup(metrics);

      var minWaitingTime = waitingTimesMetrics.min;
      var maxWaitingTime = waitingTimesMetrics.max;

      minWaitingTime = Math.max(minWaitingTime, (this.threshold / 100) * maxWaitingTime) - 1;

      var cumulativeWaitingTimes = waitingTimesMetrics.cumulativeWaitingTimes;
      //Create a scale to map the waiting times to opacity
      var exponent = 2;
      var opacityScale = d3.scalePow().exponent(exponent).domain([minWaitingTime, maxWaitingTime]).range([0.25, 1]);
      // var opacityScale = d3.scaleLinear().domain([minWaitingTime, maxWaitingTime]).range([0, 1]);
      //Create a scale to map the waiting times to width
      var widthScale = d3.scalePow().exponent(exponent).domain([minWaitingTime, maxWaitingTime]).range([5, 10]);
      // var widthScale = d3.scaleLinear().domain([minWaitingTime, maxWaitingTime]).range([2, 10]);

      //Apply the scale to the elements in the paths
      cumulativeWaitingTimes.forEach((waitingTime) => {
        if (waitingTime.group1.id == waitingTime.group2.id) {
          return;
        }

        var opacity = opacityScale(waitingTime.val);
        if (waitingTime.val == 0) {
          opacity = 0;
        }

        var width = widthScale(waitingTime.val);
        if (waitingTime.val == 0) {
          width = 0;
        }

        //Stop the transitions
        this.visualPathGroups[waitingTime.group1.id][waitingTime.group2.id].selectAll("path").transition();
        this.visualPathGroups[waitingTime.group2.id][waitingTime.group1.id].selectAll("path").transition();
        //.transition().duration(250)

        var val1 = this.getRelativeCumulativeMetrics(waitingTime.group1.id, waitingTime.group2.id);
        var val2 = this.getRelativeCumulativeMetrics(waitingTime.group2.id, waitingTime.group1.id);

        this.setGradientMap(val1, val2, this.idToPosition[waitingTime.group1.id], this.idToPosition[waitingTime.group2.id], false);
        this.setGradientMap(val2, val1, this.idToPosition[waitingTime.group2.id], this.idToPosition[waitingTime.group1.id], false);

        this.visualPathGroups[waitingTime.group1.id][waitingTime.group2.id]
          .selectAll("path")
          .transition()
          .duration(250)
          .ease(d3.easeLinear)
          .style("opacity", opacity)
          .style("mix-blend-mode", "darken")
          .style("stroke-width", width + "px");
        this.visualPathGroups[waitingTime.group2.id][waitingTime.group1.id]
          .selectAll("path")
          .transition()
          .duration(250)
          .ease(d3.easeLinear)
          .style("opacity", opacity)
          .style("mix-blend-mode", "darken")
          .style("stroke-width", width + "px");
      });
    },

    getInitialOrFinalMask() {
      var projectNames = this.$store.state.simulator.params.projectNames;
      var resourceGroups = this.getResourceGroups();

      //Initialise the resourcegroup mask
      var mask = {};
      resourceGroups.forEach((resourceGroup) => {
        mask[resourceGroup.id] = false;
        this.resourceMask[resourceGroup.id] = {};

        resourceGroups.forEach((resourceGroup2) => {
          this.resourceMask[resourceGroup.id][resourceGroup2.id] = false;
        });
      });

      projectNames.forEach((projectName) => {
        var currProject = this.$store.state.simulator.projectPool.getNewProject(projectName, 0);
        // If any of the final or initial task are off that resourgroup, mask it
        currProject.finalTasks.forEach((task) => {
          mask[task.resourceGroupID] = true;
        });

        currProject.initialTasks.forEach((task) => {
          mask[task.resourceGroupID] = true;
        });

        currProject.taskArray.forEach((task) => {
          task.childTasks.forEach((childTask) => {
            this.resourceMask[task.resourceGroupID][childTask.resourceGroupID] = true;
          });
        });
      });

      return mask;
    },
    getOffset(x, y) {
      var offset = 250;
      if (x < 0) {
        offset *= -1;
      }
      return { x: x + offset, y: y };
    },
  },
};
</script>

<style scoped>
.flow-animation-base-container {
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
}
.container {
  margin: 0;
  width: 100%;
  height: 100%;
  padding: 10px;
}
.local-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.topcontainer {
  position: absolute;
  display: flex;
  margin-top:15px;
  padding-right:10px;
  padding-left:20px;
  width: 100%;
}

.slidecontainer {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 10px;
  padding-left: 10px;
  display: flex;
}

.thresholdslidecontainer {
  padding: 10px;
  padding-left: 15px;
  padding-right: 15px;
}

/* The slider itself */
.indexslider {
  -webkit-appearance: none; /* Override default CSS styles */
  appearance: none;
  width: 100%; /* Full-width */
  height: 25px; /* Specified height */
  background: #d3d3d3; /* Grey background */
  outline: none; /* Remove outline */
  opacity: 0.7; /* Set transparency (for mouse-over effects on hover) */
  -webkit-transition: 0.2s; /* 0.2 seconds transition on hover */
  transition: opacity 0.2s;
  display: flex;
}

/* Mouse-over effects */
.indexslider:hover {
  opacity: 1; /* Fully shown on mouse-over */
}

.custom-subheader {
  font-size: 16px; /* Adjust the font size as needed */

  padding: 0px;
  padding-left: 17px;
  padding-top: 13px;
  margin: 0px;
  margin-top: 14px;
  margin-bottom: 5px;
  height: 20px;
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.indexslider::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 25px; /* Set a specific slider handle width */
  height: 25px; /* Slider handle height */
  background: #3f51b5; /* Green background */
  cursor: pointer; /* Cursor on hover */
}

.options {
}

.indexslider::-moz-range-thumb {
  width: 25px; /* Set a specific slider handle width */
  height: 25px; /* Slider handle height */
  background: #3f51b5; /* Green background */
  cursor: pointer; /* Cursor on hover */
}

.hourIndex{
  color: #3d3d3d;
  font-weight: bold;
  font-size: 1.4em;
  width: 160px;
  min-width: 160px;
  max-width: 160px;
  
}

.indexslider {
  -webkit-appearance: none;
  width: 100%;
  height: 10px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  float: "right";
}

.indexslider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #3f51b5; /* Green background */
  cursor: pointer;
}

.indexslider::-moz-range-thumb {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #3f51b5; /* Green background */
  cursor: pointer;
}

.legend {
  width: 300px;
  height: 100%;
  max-width: 300px;
  background-color: #fdfdfd;
  border-left: solid 1px #dcdcdc;

  font-size: 25px;
  position: absolute;
  right: 0;
  top: 0;
}

.header {
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 15px;
  color: #4a4a4a;
  display: flex;
  padding: 17px;
  padding-bottom: 0;
}
</style>
